import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@doxyme/ui';
import { FormattedMessage } from 'react-intl';
export const AccessLevelModal = ({ isOpen, addToAllClinicMembers, addToPersonal, onClose, }) => {
    return (<Modal className="teleconsent-access-level-modal" isOpen={isOpen}>
      <ModalHeader onClose={onClose}>
        <FormattedMessage tagName="h4" id="account.administration.teleconsent.access-level.title" defaultMessage="Select access level"/>
      </ModalHeader>
      <ModalBody>
        <div data-testId="access-modal-description">
          <FormattedMessage id="account.administration.teleconsent.access-level.text" defaultMessage="Would you like this consent form to be available for all of your providers?"/>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="ui-modal-actions">
          <Button size="medium" onClick={addToPersonal} btnStyle="outline" color="secondary" data-testId="access-modal-just-me-btn">
            <FormattedMessage id="account.administration.teleconsent.access-level.personal-button" defaultMessage="No, just me"/>
          </Button>
          <Button size="medium" onClick={addToAllClinicMembers} data-testId="access-modal-all-providers-btn">
            <FormattedMessage id="account.administration.teleconsent.access-level.all-button" defaultMessage="Yes, all providers"/>
          </Button>
        </div>
      </ModalFooter>
    </Modal>);
};
